/* Foamera — MOBILE-ONLY steps-first PDP

   Desktop is deliberately left EXACTLY as the theme built it:
     right column = title / trust / price / prose (bullets + tabs) / payment
     configurator = full-width block below.

   Mobile only (≤1023px): everything stacks, and the prose + payment row sat
   between the price and the steps — pushing the configurator ~600px down.
   So on mobile we move ONLY the prose block and the payment row to the end of
   the step container, under Review & Confirm. The steps then land right under
   the price. The step container itself is never moved.

   Reversible: original positions are captured before the first move and restored
   if the viewport crosses back to desktop.
   Step logic, step order and all imagery are untouched.

   ── 2026-09-10 düzeltmesi ────────────────────────────────────────────────
   Önceki sürüm oturum başına 100'den fazla şu hatayı fırlatıyordu:
     NotFoundError: Failed to execute 'insertBefore' on 'Node':
     The node before which the new node is to be inserted is not a child of this node.

   İki sebebi vardı:
     1) `review` querySelector ile HERHANGİ bir derinlikte bulunuyor, ama
        insertBefore `grid` üzerinde çağrılıyordu. review grid'in torunu ise
        `review.nextSibling` grid'in çocuğu değildir → istisna.
     2) `put()` anlık görüntüdeki `next` düğümünü kullanıyor; o düğüm aradan
        DOM değişince artık aynı ebeveynin çocuğu olmayabiliyor → istisna.

   Çözüm: her yerleştirme referansın gerçek ebeveynine göre yapılıyor ve
   referans geçersizse appendChild'a düşülüyor. Ayrıca yerleştirme bir kez
   başarılı olduğunda 250ms'lik yoklama durduruluyor — CPU boşuna yanmıyor. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 1023px)');
  var saved = null;

  function snap(el) {
    return el && el.parentNode ? { el: el, parent: el.parentNode, next: el.nextSibling } : null;
  }

  /* Tek güvenli yerleştirme yolu. ref yoksa ya da ref parent'ın çocuğu
     değilse sona ekler; asla istisna fırlatmaz. */
  function place(parent, el, ref) {
    if (!parent || !el) return false;
    try {
      if (ref && ref.parentNode === parent) parent.insertBefore(el, ref);
      else parent.appendChild(el);
      return true;
    } catch (e) {
      return false;
    }
  }

  function put(s) {
    if (!s || !s.parent) return;
    /* s.next aradan taşınmış olabilir — place() bunu kendisi ele alıyor */
    place(s.parent, s.el, s.next);
  }

  function apply() {
    var grid = document.querySelector('.pcfg-below-grid');
    if (!grid) return false;

    var review = grid.querySelector('[data-pcfg-review-section]');
    var anchor = review || grid.lastElementChild;
    if (!anchor) return false;

    var slot = document.querySelector('[data-pcfg-info-slot]');
    var pay = document.querySelector('.pcfg__payment-row');
    if (!slot && !pay) return false;

    if (!saved) saved = {};
    /* capture home position BEFORE the first move so desktop can be restored */
    if (slot && !saved.slot && !slot.classList.contains('fmr-info-below')) saved.slot = snap(slot);
    if (pay && !saved.pay && !pay.classList.contains('fmr-pay-below')) saved.pay = snap(pay);

    /* KRİTİK: anchor grid'in torunu olabilir. Yerleştirme her zaman
       anchor'ın GERÇEK ebeveynine göre yapılır, grid'e göre değil. */
    var host = anchor.parentNode || grid;
    var ok = false;

    if (slot) {
      slot.classList.add('fmr-info-below');
      ok = place(host, slot, anchor.nextSibling) || ok;
      anchor = slot;
      host = anchor.parentNode || host;
    }
    if (pay) {
      pay.classList.add('fmr-pay-below');
      ok = place(host, pay, anchor.nextSibling) || ok;
    }
    return ok;
  }

  function undo() {
    if (!saved) return;
    if (saved.slot) { saved.slot.el.classList.remove('fmr-info-below'); put(saved.slot); }
    if (saved.pay) { saved.pay.el.classList.remove('fmr-pay-below'); put(saved.pay); }
  }

  function sync() {
    if (MQ.matches) return apply();
    undo();
    return true;
  }

  function boot() {
    if (!document.getElementById('pcfg-root')) return;
    sync();
    /* the theme builds .pcfg-below-grid and cfg-core.js fills the info slot async.
       Yerleştirme tuttuğu anda yoklamayı bırak — eskiden 24 tur boyunca
       her 250ms'de bir DOM'u dövüyordu. */
    var t = 0;
    var iv = setInterval(function () {
      var done = sync();
      if (done || ++t > 24) clearInterval(iv);
    }, 250);
    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    else if (MQ.addListener) MQ.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ── Journal karusel gezinmesi — 13.09.2026 ──────────────────────────────
   Blok mobilde 1219px yer kaplıyordu; kartlar yatay kaydırmaya alındı
   (CSS: foamera-ux.css 24. bölüm). Kaydırılabilir olduğunun görünür tek
   işareti kenardan taşan sonraki kart; Furkan'ın gönderdiği referansta
   ayrıca yuvarlak bir ileri oku var. Onu burada enjekte ediyoruz.

   Düğmeler .pjournal__wrap içine konur, dikey olarak ızgaranın ortasına
   hizalanır ve sınırlarda gizlenir. Izgara kaydırılamıyorsa (masaüstünde
   üç kart yan yana sığıyor) ikisi de gizli kalır — ekstra kural gerekmez. */
(function () {
  'use strict';

  var ICON = {
    next: 'M9 5l7 7-7 7',
    prev: 'M15 5l-7 7 7 7'
  };

  function button(dir, grid) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fmr-jnav fmr-jnav--' + dir;
    b.setAttribute('aria-label', dir === 'next' ? 'Next articles' : 'Previous articles');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + ICON[dir] + '" fill="none" stroke="currentColor" stroke-width="1.9" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    b.addEventListener('click', function () {
      var card = grid.querySelector('.pjournal__card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 12;
      var step = card.getBoundingClientRect().width + gap;
      /* scrollBy yerine indeksten hesap: kullanıcı animasyon sürerken ikinci
         kez tıklarsa scrollBy bir öncekini iptal edip yerinde sayıyordu
         (ölçüldü: 700ms arayla iki tık → 290'da kaldı). Mevcut konumdan
         en yakın kart indeksini bulup hedefi sınırlara kırpıyoruz. */
      var max = grid.scrollWidth - grid.clientWidth;
      var i = Math.round(grid.scrollLeft / step);
      var target = Math.max(0, Math.min(max, (i + (dir === 'next' ? 1 : -1)) * step));
      grid.scrollTo({ left: target, behavior: 'smooth' });
    });
    return b;
  }

  function setup(grid) {
    if (grid.getAttribute('data-fmr-jnav')) return;
    grid.setAttribute('data-fmr-jnav', '1');

    var host = grid.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var prev = button('prev', grid);
    var next = button('next', grid);
    host.appendChild(prev);
    host.appendChild(next);

    function sync() {
      /* dikey konum: ızgaranın ortası (başlık yüksekliği sayfadan sayfaya değişir) */
      var mid = grid.offsetTop + grid.clientHeight / 2;
      prev.style.top = mid + 'px';
      next.style.top = mid + 'px';

      var max = grid.scrollWidth - grid.clientWidth;
      var x = grid.scrollLeft;
      prev.hidden = max <= 2 || x <= 2;
      next.hidden = max <= 2 || x >= max - 2;
    }

    grid.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) { try { new ResizeObserver(sync).observe(grid); } catch (e) {} }
    sync();
    /* görseller yüklendikçe yükseklik değişir */
    window.addEventListener('load', sync);
  }

  function boot() {
    var grids = document.querySelectorAll('.pjournal__grid');
    for (var i = 0; i < grids.length; i++) setup(grids[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ── Konfigürator sticky çubuğu ile adım senkronu — 16.09.2026 ─────────────
   ÖLÇÜLEN SORUN (mobil, /products/outdoor-round-cushions, 375px):
       açık panel 1 → kendi Continue'su "Continue", disabled: true
       sticky düğme → "Start Customizing", title="Enter all dimensions", disabled DEĞİL
   Sticky çubuk konfigüratörün hangi adımda olduğunu bilmiyor; en sonda bile
   "Start Customizing" yazıyor. Üstelik engel sebebi SADECE `title` özniteliğinde —
   mobilde tooltip yoktur, müşteri neden ilerleyemediğini hiç göremiyor.

   Bu modül iki şey yapar, uygulamanın mantığına dokunmadan:
     1. Etiket senkronu — sticky düğme açık adımın Continue etiketini yansıtır;
        engel kalmayınca "Add to cart" olur.
     2. Sebebi GÖRÜNÜR kılar — title metni çubuğun içinde bir satır olur.

   Düğme bilerek `disabled` YAPILMIYOR: temadaki cfg-sticky-continue-fix.liquid
   tıklamayı yakalayıp kullanıcıyı eksik adıma götürüyor; disabled olsa o tıklama
   hiç oluşmaz ve kullanıcı çıkmazda kalırdı. Yerine aria-disabled + soluk stil.

   BAĞIMLILIK: engel sebebi uygulamanın `title` özniteliğinden okunuyor. Extension
   ileride `title`'ı bırakıp yapısal bir alana geçerse burası da güncellenmeli,
   yoksa etiket "Add to cart"ta takılı kalır. */
(function(){
  if (window.__pcfgStickySync) return; window.__pcfgStickySync = 1;

  var CONFIRM_RE = /confirm/i;                                                   // FMR-FIX F04
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 479px)') : null; // FMR-FIX F24

  function openPanel(){
    var open = [].slice.call(document.querySelectorAll('[data-pcfg-panel].pcfg__panel--open'));
    if (!open.length) return null;
    var best=null, bestN=-1, backrest=null;
    for (var i=0;i<open.length;i++){
      var k = open[i].getAttribute('data-pcfg-panel');
      if (k==='backrest'){ backrest=open[i]; continue; }
      var n = parseInt(k,10);
      if (!isNaN(n) && n>bestN){ bestN=n; best=open[i]; }
    }
    return best || backrest;
  }

  function hintNode(bar){
    var el = bar.querySelector('[data-fmr-sticky-hint]');
    if (!el){
      el = document.createElement('span');
      el.className = 'fmr-sticky-hint';
      el.setAttribute('data-fmr-sticky-hint','');
      el.setAttribute('role','status');
      var info = bar.querySelector('.pcfg__sticky-info') || bar;
      info.appendChild(el);
    }
    return el;
  }

  /** True when a control is blocked by EITHER mechanism: the native `disabled`
      property, or aria-disabled (used where a tap must still be able to say
      why it is blocked). */
  function isBlocked(el){
    if (!el) return true;
    return !!el.disabled || el.getAttribute('aria-disabled') === 'true';
  }

  function sync(){
    var bar = document.querySelector('.pcfg__sticky-bar');
    if (!bar) return;
    var btn = bar.querySelector('[data-pcfg-add-to-cart]');
    if (!btn) return;
    // FMR-FIX F91: cfg-core writes title = reason || '' on every updateATCState(); before its first
    // run the attribute does not exist. Reading "no title" as "ready" flashed "Add to cart" on an
    // unconfigured cushion for ~0.6 s (then "Continue") — leave the server label alone until then.
    if (btn.getAttribute('title') === null) return;

    var reason = (btn.getAttribute('title') || '').trim();
    var panel  = openPanel();
    var label, hint = '';

    if (reason === ''){
      label = 'Add to cart';
    } else if (panel){
      var cont = panel.querySelector('[data-pcfg-continue]');
      label = cont ? ((cont.textContent||'').trim() || 'Continue') : 'Continue';
      // A Continue button can be blocked two different ways, and this used to
      // test only one of them. cfg-core.js now marks step 1's Continue with
      // aria-disabled (so that tapping it can explain what is missing) while
      // steps 3 and 5 still use the hard `disabled` property. Testing
      // `.disabled` alone made step 1 report "not blocked", which cleared the
      // hint AND set aria-disabled="false" on the sticky button — so the bar
      // looked ready to go while the configurator was in fact blocked. That is
      // worse than showing nothing, so both forms are checked here.
      if (!cont || isBlocked(cont)) hint = reason;
    } else {
      label = 'Continue';
      hint  = reason;
      // FMR-FIX F04: every step is done and no panel is open, so the only thing left is
      // the "Everything looks good" tick — name that destination (the section's own title).
      if (CONFIRM_RE.test(reason)) label = 'Review & Confirm';
    }
    // FMR-FIX F24: the mirrored "Continue to Customizations" (262px) squeezed the price and
    // the hint to 60–90px on phones ('$131.7', 'No fabric chosei'). On phones a long
    // "Continue to …" label falls back to the configurator's own short "Continue".
    if (PHONE && PHONE.matches && label.length > 18 && /^Continue to /i.test(label)) label = 'Continue';

    if ((btn.textContent||'').trim() !== label) btn.textContent = label;
    btn.setAttribute('aria-disabled', hint ? 'true' : 'false');
    btn.classList.toggle('pcfg__sticky-atc--blocked', !!hint);

    var h = hintNode(bar);
    if ((h.textContent||'') !== hint) h.textContent = hint;
    h.hidden = !hint;
    // FMR-FIX F91: the real hint now fills the line cfg-tailor-video.liquid held open from first paint
    if (hint) bar.classList.add('fmr-hint-live');
  }

  var queued = false;
  function schedule(){
    if (queued) return; queued = true;
    requestAnimationFrame(function(){ queued = false; try{ sync(); }catch(e){} });
  }

  /* FMR-FIX F04 — THEME STOP-GAP (the real fix belongs in the extension, cfg-core.js
     scrollToNextIncompleteStep). MEASURED on a phone: with fabric chosen, a shopper who only
     taps the sticky button goes Customizations → Special Instructions → Review (all panels
     closed, reason "Confirm your selections") → and the next tap reopens Step 4, forever.
     The app's recovery path does scrollToStepAndOpen(state.confirmed ? 7 : 4).
     Here: when no panel is open and the only block is the confirmation, the tap scrolls the
     "Everything looks good" row into the free space above the bar and focuses its checkbox
     (it never ticks it). A no-op once the extension sets window.__PCFG_CONFIRM_SCROLL_FIXED. */
  function injectCueCss(){
    if (document.getElementById('fmr-confirm-cue-css')) return;
    var st = document.createElement('style');
    st.id = 'fmr-confirm-cue-css';
    st.textContent = '.fmr-confirm-cue{outline:2px solid #8B5E3C;outline-offset:4px;}';
    (document.head || document.documentElement).appendChild(st);
  }
  var cueT = 0;
  function scrollToConfirm(){
    var chk = document.querySelector('[data-pcfg-confirm-check]');
    if (!chk) return false;
    var row = (chk.closest && (chk.closest('.pcfg__confirm-row') || chk.closest('label'))) || chk;
    var r = row.getBoundingClientRect();
    if (!r.width && !r.height) return false;            // not rendered → leave it to the app
    var bar = document.querySelector('.pcfg__sticky-bar');
    var barH = bar ? bar.getBoundingClientRect().height : 0;
    var room = window.innerHeight - barH;
    var top = (window.pageYOffset || 0) + r.top - Math.max(16, (room - r.height) / 2);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, Math.max(0, top)); }
    try { chk.focus({ preventScroll: true }); } catch (e) {}
    var cue = (chk.closest && chk.closest('label')) || row;   // outline the tick itself, not the ATC beside it
    injectCueCss();
    cue.classList.add('fmr-confirm-cue');
    clearTimeout(cueT);
    cueT = setTimeout(function(){ cue.classList.remove('fmr-confirm-cue'); }, 1600);
    return true;
  }
  document.addEventListener('click', function(e){
    if (window.__PCFG_CONFIRM_SCROLL_FIXED === true) return;
    var btn = e.target && e.target.closest ? e.target.closest('.pcfg__sticky-bar [data-pcfg-add-to-cart]') : null;
    if (!btn) return;
    var reason = (btn.getAttribute('title') || '').trim();
    if (!CONFIRM_RE.test(reason) || openPanel()) return;
    if (!scrollToConfirm()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  function boot(){
    var root = document.getElementById('pcfg-root');
    if (!root) return;
    sync();
    if (PHONE) {                                                 // FMR-FIX F24
      if (PHONE.addEventListener) PHONE.addEventListener('change', schedule);
      else if (PHONE.addListener) PHONE.addListener(schedule);
    }
    try {
      new MutationObserver(schedule).observe(root, {
        subtree:true, childList:true, characterData:true,
        attributes:true, attributeFilter:['title','class','disabled','aria-disabled']
      });
    } catch(e){}
    // FMR-FIX F04 (review): the sticky bar and the "Everything looks good" tick live in
    // .pcfg-below-grid, OUTSIDE #pcfg-root, so ticking the box (the app clears the button's
    // title) never re-synced the bar: it kept "Confirm your selections" and the dimmed look.
    // Watch the title itself — sync() never writes title, so this cannot loop.
    try {
      var stickyBtn = document.querySelector('.pcfg__sticky-bar [data-pcfg-add-to-cart]');
      if (stickyBtn) new MutationObserver(schedule).observe(stickyBtn, { attributes:true, attributeFilter:['title'] });
    } catch(e){}
    document.addEventListener('change', function(e){
      if (e.target && e.target.matches && e.target.matches('[data-pcfg-confirm-check]')) schedule();
    }, true);
    root.addEventListener('input',  schedule, true);
    root.addEventListener('change', schedule, true);
    root.addEventListener('click',  schedule, true);
    // FMR-FIX F91: after the shopper's first tap or key press the reserved hint line simply
    // follows the hint (any height change is then a response to their input, not a load shift).
    var live = function(e){
      if (e && e.isTrusted === false) return;
      document.removeEventListener('pointerdown', live, true);
      document.removeEventListener('keydown', live, true);
      var b = document.querySelector('.pcfg__sticky-bar');
      if (b) b.classList.add('fmr-hint-live');
    };
    document.addEventListener('pointerdown', live, true);
    document.addEventListener('keydown', live, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* FMR-FIX MO-1 — price tick on the headline price.
   cfg-core.js (FEATURE 4) restarts .pcfg__price-pulse on the sticky and review prices when the
   total changes, but never on the big [data-pcfg-default-price] under the title; the 280 ms tick
   itself (opacity + 4 px rise, reduced-motion: none) is the design group's FMR-FIX MO-1 rule in
   foamera-ux.css, which already targets all three. This restarts the same class on the headline
   price when its text really changes: only after the shopper's first input (never on the initial
   render or cfg-core's start-up writes), never to a zero price, never under reduced motion.
   It watches text only, not attributes, so toggling the class cannot re-trigger it. */
(function () {
  'use strict';
  if (!window.MutationObserver) return;
  var PULSE = 'pcfg__price-pulse';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var engaged = false;
  var EVENTS = ['pointerdown', 'keydown', 'input', 'change'];

  function engage(e) {
    if (e && e.isTrusted === false) return;  // the app's own dispatched events are not the shopper
    engaged = true;
    for (var i = 0; i < EVENTS.length; i++) document.removeEventListener(EVENTS[i], engage, true);
  }

  function boot() {
    var el = document.querySelector('[data-pcfg-default-price]');
    if (!el) return;
    var last = (el.textContent || '').trim();
    for (var i = 0; i < EVENTS.length; i++) document.addEventListener(EVENTS[i], engage, true);
    new MutationObserver(function () {
      var now = (el.textContent || '').trim();
      if (now === last) return;              // cfg-core rewrites the same text on every update
      last = now;
      if (!engaged || !/[1-9]/.test(now) || (RM && RM.matches)) return;
      el.classList.remove(PULSE);
      void el.offsetWidth;                   // restart the animation, as cfg-core does for the other two
      el.classList.add(PULSE);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ══════════════════════════════════════════════════════════════════════════
   NATIVE VALIDATION, IN ENGLISH                                  2026-09-16

   The storefront is English, but a browser set to Turkish (navigator.language
   on this store reports "tr") writes its OWN validation bubbles in Turkish:
   "Lütfen bu alanı doldurun.", "Lütfen e-posta adresine '@' işareti ekleyin."
   Nothing in the theme produces that text and nothing in the theme could
   translate it — the string comes from the browser's UI locale.

   setCustomValidity() is the one hook that replaces it. We set our own English
   message the moment a field reports invalid, and clear it on the next input
   so the field can become valid again (a custom message that is never cleared
   keeps a field permanently invalid).
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function messageFor(el) {
    var v = el.validity;
    if (!v) return '';
    var label = (el.getAttribute('aria-label')
      || el.getAttribute('placeholder')
      || el.name
      || 'this field').replace(/[*:]\s*$/, '').trim();

    if (v.valueMissing) {
      if (el.type === 'checkbox' || el.type === 'radio') return 'Please tick this to continue.';
      if (el.type === 'email') return 'Please enter your email address.';
      return 'Please fill in ' + label + '.';
    }
    if (v.typeMismatch && el.type === 'email') return 'Please enter a valid email address, like name@example.com.';
    if (v.typeMismatch && el.type === 'url') return 'Please enter a full web address, starting with https://';
    if (v.typeMismatch && el.type === 'tel') return 'Please enter a valid phone number.';
    if (v.tooShort)  return 'Please use at least ' + el.minLength + ' characters.';
    if (v.tooLong)   return 'Please use ' + el.maxLength + ' characters or fewer.';
    if (v.rangeUnderflow) return 'Please enter ' + el.min + ' or more.';
    if (v.rangeOverflow)  return 'Please enter ' + el.max + ' or less.';
    if (v.stepMismatch)   return 'Please enter a valid amount.';
    if (v.patternMismatch) return 'Please match the format asked for.';
    if (v.badInput) return 'Please check what you entered.';
    return 'Please check this field.';
  }

  document.addEventListener('invalid', function (e) {
    var el = e.target;
    if (!el || typeof el.setCustomValidity !== 'function') return;
    el.setCustomValidity(messageFor(el));
  }, true);

  function clear(e) {
    var el = e.target;
    if (el && typeof el.setCustomValidity === 'function' && el.validationMessage) {
      el.setCustomValidity('');
    }
  }
  document.addEventListener('input', clear, true);
  document.addEventListener('change', clear, true);
})();

/* ══════════════════════════════════════════════════════════════════════════
   CART PAGE — REPAIR A LINE SHOPIFY COULD NOT PRICE YET        2026-09-17

   MEASURED on the live store, reproduced twice with two different
   configurations: immediately after Add to Cart the cart page renders

       NO IMAGE · (no product title) · $0.00 · Subtotal $0.00 · TOTAL $0.00

   while /cart.js returns the correct 26844 ($268.44) for the same line.

   WHY. The configurator prices a cushion by minting a fresh Shopify variant
   at the exact price, then adding THAT variant to the cart. The add succeeds,
   but for the first seconds the new variant is not yet visible to the
   storefront's Liquid layer. sections/poufudic-cart.liquid renders
   `item.product.title`, `item.image` and `item.final_line_price` — all three
   resolve through the variant — so the row comes out nameless, imageless and
   priced at zero. A manual refresh fixes it, which is exactly the tell.

   This lands on the shopper at the worst possible moment: the instant they
   committed. Over the last 90 days 43 sessions added to cart and only 21
   reached checkout; this is the screen standing between those two numbers.

   FIX. /cart.js answers correctly the whole time, so stop trusting the
   server-rendered numbers on this page and reconcile against the JSON on
   load. Everything below is idempotent and only writes when the DOM actually
   disagrees, so a correctly-rendered cart is left untouched.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function onCartPage() {
    return !!document.querySelector('#pcrt-cart-form, [data-pcrt-total], [data-pcrt-item]');
  }

  /* toLocaleString(undefined, …) follows the BROWSER's locale, not the shop's.
     This store's own visitors report navigator.language "tr", so an undefined
     locale rendered "$158,62" — a comma — next to Liquid's "$158.62". Pin the
     locale so the repaired figure is spelled the same way the page already
     spells it. */
  function money(cents, currency) {
    var n = (cents || 0) / 100;
    try {
      return n.toLocaleString('en-US', { style: 'currency', currency: currency || 'USD' });
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  /* Compare by VALUE, never by string. Writing whenever the text differs would
     rewrite a perfectly good "$158.62" just because we spell it differently,
     and any formatting disagreement would then flicker on every load. Only a
     genuinely wrong number gets replaced. */
  function centsOf(text) {
    var t = String(text || '').replace(/[^\d.,-]/g, '');
    if (!t) return null;
    // Last separator is the decimal one, whichever it is.
    var lastDot = t.lastIndexOf('.'), lastComma = t.lastIndexOf(',');
    var cut = Math.max(lastDot, lastComma);
    var whole, frac = '';
    if (cut > -1 && t.length - cut - 1 <= 2) {
      whole = t.slice(0, cut);
      frac = t.slice(cut + 1);
    } else {
      whole = t;
    }
    whole = whole.replace(/[.,]/g, '');
    var n = parseInt(whole || '0', 10) * 100 + parseInt((frac + '00').slice(0, 2), 10);
    return isNaN(n) ? null : n;
  }

  function setMoney(el, cents, currency) {
    if (!el) return false;
    var have = centsOf(el.textContent);
    if (have === cents) return false;              // already right, leave it alone
    el.textContent = money(cents, currency);
    return true;
  }

  function setText(el, value) {
    if (el && value && (el.textContent || '').trim() !== value) el.textContent = value;
  }

  /** Give the row back its name. The Liquid printed an empty <a>; the JSON
      always carries product_title. */
  function repairTitle(row, item) {
    var link = row.querySelector('.pcrt-item__title a');
    if (!link) return;
    if ((link.textContent || '').trim()) return;          // already fine
    link.textContent = item.product_title || item.title || 'Custom cushion';
    if (!link.getAttribute('href') && item.url) link.setAttribute('href', item.url);
  }

  /** Replace the "No image" placeholder once the JSON gives us a real one. */
  function repairImage(row, item) {
    var holder = row.querySelector('.pcrt-item__img');
    if (!holder) return;
    if (holder.querySelector('img')) return;              // already fine
    var src = item.image || item.featured_image && item.featured_image.url;
    if (!src) return;
    var placeholder = holder.querySelector('.pcrt-item__img-placeholder');
    if (placeholder) placeholder.remove();
    var img = document.createElement('img');
    img.src = src;
    img.alt = item.product_title || item.title || '';
    img.width = 120;
    img.height = 120;
    img.loading = 'lazy';
    img.decoding = 'async';
    holder.appendChild(img);
    if (!holder.getAttribute('href') && item.url) holder.setAttribute('href', item.url);
  }

  function reconcile(cart) {
    if (!cart || !cart.items) return false;
    var cur = cart.currency;
    var changed = false;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var row = document.querySelector('[data-pcrt-item="' + item.key + '"]');
      if (!row) continue;
      if (setMoney(row.querySelector('[data-pcrt-line-total]'), item.final_line_price, cur)) changed = true;
      repairTitle(row, item);
      repairImage(row, item);
    }

    if (setMoney(document.querySelector('[data-pcrt-subtotal]'), cart.items_subtotal_price, cur)) changed = true;
    if (setMoney(document.querySelector('[data-pcrt-total]'), cart.total_price, cur)) changed = true;
    if (setMoney(document.querySelector('[data-pcrt-sticky-total]'), cart.total_price, cur)) changed = true;

    var countEl = document.querySelector('.pcrt-hero__count strong');
    if (countEl) setText(countEl, String(cart.item_count));

    return changed;
  }

  /** The variant usually becomes visible within a second or two. Re-check a
      few times with a widening gap rather than once, so a slow propagation
      still resolves without the shopper touching anything — then stop, so
      this never becomes a polling loop on a healthy page. */
  var DELAYS = [0, 400, 1200, 2500, 5000];

  function pass(i) {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        reconcile(cart);
        // Keep going only while something on the page still reads as zero.
        var totalEl = document.querySelector('[data-pcrt-total]');
        var stillZero = totalEl && /^[^\d]*0([.,]00)?$/.test((totalEl.textContent || '').trim());
        var missingName = !!document.querySelector('.pcrt-item__title a:empty');
        if ((stillZero || missingName) && i + 1 < DELAYS.length) {
          setTimeout(function () { pass(i + 1); }, DELAYS[i + 1]);
        }
      })
      .catch(function () {});
  }

  function boot() {
    if (!onCartPage()) return;
    pass(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
